import { Translation } from 'react-i18next';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ColumnProps } from '@/components';

import { RestrictionRecord } from './types';

export const columns: Array<ColumnProps<RestrictionRecord>> = [
  {
    title: <Translation>{t => t('RestrictionRecords_columns.1jvfx')}</Translation>,
    key: '_createAt',
    width: '182px',
    skeleton: <Skeleton width={100} />,
  },
  {
    title: <Translation>{t => t('RestrictionRecords_columns.135lv3o')}</Translation>,
    key: '_duration',
    width: '120px',
    skeleton: <Skeleton width={42} />,
  },
  {
    title: <Translation>{t => t('RestrictionRecords_columns.14f0m04')}</Translation>,
    key: 'reason',
    width: '284px',
    skeleton: <Skeleton width={160} />,
  },
];
